"use client";

import { cn } from "@/lib/utils";
import { Search, X } from "lucide-react";
import { useRef, useState } from "react";
import * as Dialog from "../../clients/Dialog";
import { useScopedI18n } from "@/messages/client";
import useLocaleRouter from "@/hooks/useLocaleRouter";
import Divider from "./Divider";
import RouterLink from "@/components/ui/router-link";

export function GlobalSearch() {
  const t = useScopedI18n("全局导航条");

  const router = useLocaleRouter();

  const [value, setValue] = useState("");

  const ref = useRef<HTMLInputElement>(null);

  return (
    <div className="hidden h-[34px] flex-1 pl-12 md:flex">
      <div className="flex flex-col">
        <div className="relative flex min-h-[34px] w-[300px] overflow-hidden rounded-md border border-[#2C2C2C] transition-all duration-300 focus-within:border-primary hover:border-primary">
          <div className="relative flex-1">
            <input
              ref={ref}
              value={value}
              onChange={(e) => {
                setValue(e.target?.value);
              }}
              placeholder={t("搜索提示语")}
              className="h-full w-full px-4 pb-0.5 text-sm outline-none placeholder:text-xs placeholder:leading-none placeholder:text-[#E5E5E5]"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  router.push(`/global-search?keyword=${value}`);
                }
              }}
            />

            {value && (
              <div
                className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setValue("");
                  ref.current?.focus();
                }}>
                <X size={16} />
              </div>
            )}
          </div>
          <div className="flex h-full items-center pr-2">
            <Divider className="h-[14px] bg-[#515151] lg:mx-1.5" />
            <Search
              size={18}
              className="cursor-pointer text-[#2C2C2C]"
              onClick={() => {
                router.push(`/global-search?keyword=${value}`);
                setValue("");
              }}
            />
          </div>
        </div>

        <div>
          <RouterLink
            href="/cross-reference"
            className="inline-block text-xs text-[#17A29E]">
            {t("交叉参考搜索")}
          </RouterLink>
        </div>
      </div>
    </div>
  );
}

export function MobileGlobalSearch() {
  const t = useScopedI18n("全局导航条");

  const [open, setOpen] = useState(false);

  const [value, setValue] = useState("");

  const router = useLocaleRouter();

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <div
          className={cn("cursor-pointer text-[#2C2C2C]", {
            "text-primary": open,
          })}>
          <Search size={20} />
        </div>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="fixed left-0 top-11 z-40 w-full border-b border-[#E5E5E5] bg-white shadow-[0px_2px_8px_0px_rgba(0,0,0,0.1)] outline-none !duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:slide-out-to-top-1/4 data-[state=open]:slide-in-from-top-1/4">
          <div className="flex h-14 w-full items-center space-x-4 bg-[#F7F7F7] px-6">
            <div className="relative h-8 flex-1 overflow-hidden rounded-2xl border border-[#2C2C2C] transition-all duration-200 focus-within:border-2 focus-within:border-primary">
              <div className="absolute left-2 top-1/2 -translate-y-1/2">
                <Search size={16} color="#2C2C2C" />
              </div>
              <input
                value={value}
                onChange={(e) => {
                  setValue(e.target?.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    router.push(`/global-search?keyword=${value}`);
                  }
                }}
                placeholder={t("搜索提示语")}
                className="h-full w-full rounded-2xl px-8 outline-none placeholder:text-sm placeholder:text-[#A6A6A6]"
              />
            </div>

            <div className="flex-shrink-0">
              <Dialog.Close asChild>
                <button className="text-sm text-[#2C2C2C]">{t("取消")}</button>
              </Dialog.Close>
            </div>
          </div>

          {/* <div className="px-8 py-2">
            <div className="text-base font-medium text-[#2C2C2C]">
              {t("热门搜索")}
            </div>

            <div className="mt-3 space-y-1">
              <p className="text-xs text-[#A6A6A6]">车载摄像头</p>
            </div>
          </div> */}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
